<template>
  <div>
    <b-modal
      id="modal-edit-peringatan"
      size="lg"
      centered
      :title="$store.state.modal.editDataPeringatan"
      header-bg-variant="warning"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.tanggal" label-cols-md="3">
          <DatePicker
            style="width: 100%"
            :state="checkIfValid('tanggalPeringatan')"
            v-model="$v.dataPeringatanEdit.tanggalPeringatan.$model"
            :placeholder="dataPeringatan.tanggal"
          ></DatePicker>
        </b-form-group>

        <b-form-group :label="$store.state.form.jenisPelanggaran" label-cols-md="3">
          <Multiselect
            :state="checkIfValid('poolPelanggaranIdEdit')"
            v-model="$v.dataPeringatanEdit.poolPelanggaranIdEdit.$model"
            :options="dataPelanggaran"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaPelanggaran"
            placeholder="-- Pilih --"
          ></Multiselect>
        </b-form-group>

        <b-form-group :label="$store.state.form.keterangan" label-cols-md="3">
          <b-form-textarea
            rows="3"
            :state="checkIfValid('keteranganPeringatan')"
            v-model="$v.dataPeringatanEdit.keteranganPeringatan.$model"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group :label="$store.state.form.masaBerlaku" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('masaBerlakuPeringatan')"
            v-model="$v.dataPeringatanEdit.masaBerlakuPeringatan.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit-peringatan')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalEdit",
  props: ["dataPeringatan", "dataPelanggaran", "edit"],
  data() {
    return {
      dataPeringatanEdit: {
        tanggalPeringatan: "",
        poolPelanggaranIdEdit: "",
        keteranganPeringatan: "",
        masaBerlakuPeringatan: "",
      },
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataPeringatanEdit, null, 4);
    },
    isValid() {
      return !this.$v.dataPeringatanEdit.$invalid;
    },
    isDirty() {
      return this.$v.dataPeringatanEdit.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataPeringatanEdit: {
      tanggalPeringatan: {
        required,
      },
      keteranganPeringatan: {
        required,
      },
      masaBerlakuPeringatan: {
        required,
      },
      poolPelanggaranIdEdit: {
        required,
      },
    },
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        for (let i = 0; i < this.dataPelanggaran.length; i++) {
          if (
            this.dataPelanggaran[i].id == this.dataPeringatan.poolPelanggaranId
          ) {
            this.dataPeringatanEdit.poolPelanggaranIdEdit =
              this.dataPelanggaran[i];
          }
        }
        this.dataPeringatanEdit.keteranganPeringatan =
          this.dataPeringatan.keteranganPeringatan;
        this.dataPeringatanEdit.masaBerlakuPeringatan =
          this.dataPeringatan.masaBerlakuPeringatan;
        this.dataPeringatanEdit.tanggalPeringatan =
          this.dataPeringatan.tanggalPeringatan;
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataPeringatanEdit[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },

    simpan() {
      let vm = this;
      // console.log(vm.data, "ini data simpan");
      vm.dataPeringatan.poolPelanggaranId =
        vm.dataPeringatanEdit.poolPelanggaranIdEdit.poolPelanggaranId;
      vm.dataPeringatan.tanggalPeringatan = vm.$moment(
        vm.dataPeringatanEdit.tanggalPeringatan
      );
      vm.dataPeringatan.keteranganPeringatan =
        vm.dataPeringatanEdit.keteranganPeringatan;
      vm.dataPeringatan.masaBerlakuPeringatan =
        vm.dataPeringatanEdit.masaBerlakuPeringatan;
      console.log(vm.dataPeringatan, "ini data peringatan");
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("peringatan/update", vm.dataPeringatan)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA PERINGATAN",
                showing: true,
              });
              this.$bvModal.hide("modal-edit-peringatan");
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
};
</script>
